import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';

const emsName = 'DPSV2FooterCopyrightMobile';

export const CopyrightMobile = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
